export default "__VITE_ASSET__B_I4UWwa__"